enum TradeStatus {
  NotSet = 'notset',
  Unclaimed = 'unclaimed',
  Active = 'active',
  Expired = 'expired',
  Deleted = 'deleted',
  Completed = 'completed'
}

export default TradeStatus;
